(() => {
  // Move keyboard focus to the server-rendered form status (success or error)
  // so screen readers announce it after the native POST round-trip.
  const status = document.querySelector('.coming-soon__status');
  if (status) status.focus();

  // Char-scramble reveal on the community link.
  const link = document.querySelector('[data-scramble]');
  if (!link) return;

  const el = link.querySelector('[data-scramble-text]');
  const IDLE_TEXT = link.dataset.scrambleIdle || el.textContent;
  const HOVER_TEXT = link.dataset.scrambleHover || IDLE_TEXT;
  const ASCII_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ89!@#$%&*<>?/\\|[]{}^~';
  const DURATION = 300;
  const REVERSE_DURATION = 220;

  let animFrame = null;
  let startTime = null;
  let direction = 'idle';

  const rand = (chars) => chars[Math.floor(Math.random() * chars.length)];

  function renderSpans(to, progress) {
    const fragment = document.createDocumentFragment();
    for (let i = 0; i < to.length; i += 1) {
      const targetChar = to[i];
      if (targetChar === ' ') {
        fragment.append(' ');
        continue;
      }
      const span = document.createElement('span');
      const threshold = (i / to.length) * 0.7 + 0.1;
      if (progress >= threshold) {
        span.textContent = targetChar;
      } else {
        span.textContent = rand(ASCII_CHARS);
        span.className = 'coming-soon__char--scrambling';
      }
      fragment.append(span);
    }
    el.replaceChildren(fragment);
  }

  function animate(to, duration, onDone) {
    if (animFrame) cancelAnimationFrame(animFrame);
    startTime = null;
    function step(ts) {
      if (!startTime) startTime = ts;
      const progress = Math.min((ts - startTime) / duration, 1);
      renderSpans(to, progress);
      if (progress < 1) {
        animFrame = requestAnimationFrame(step);
      } else {
        el.textContent = to;
        animFrame = null;
        if (onDone) onDone();
      }
    }
    animFrame = requestAnimationFrame(step);
  }

  link.addEventListener('mouseenter', () => {
    if (direction === 'forward') return;
    direction = 'forward';
    animate(HOVER_TEXT, DURATION, () => {
      direction = 'done';
    });
  });

  link.addEventListener('mouseleave', () => {
    if (direction === 'reverse') return;
    direction = 'reverse';
    animate(IDLE_TEXT, REVERSE_DURATION, () => {
      direction = 'idle';
    });
  });
})();
